// removed by extract-text-webpack-plugin
module.exports = {"list-item-category-S":"list-item-category-S","wrap-list-item":"wrap-list-item","product-wrap":"product-wrap","product":"product"};


//////////////////
// WEBPACK FOOTER
// ./components/category-detail/list-category-item/style.scss
// module id = ./components/category-detail/list-category-item/style.scss
// module chunks = 0